import React, { useEffect } from "react";
import dateUtil from "../utils/dateUtil";
import Menu from "../components/menu";
import ReactGA from "react-ga4";

const LOCALES = {
  titre: {
    label: {
      fr: "Renseignements sur les données",
      en: "Information on the data",
    },
  },
};

const PAGE = "renseignements";

const Renseignements = ({ lang, latestDataUpdate, latestUpdateISQ }) => {
  useEffect(() => {
    //Google analytics 4
    ReactGA.event("page_view", {
      page_title: LOCALES.titre.label[lang],
    });
  }, [lang]);
  return (
    <div className="page page-renseignement">
      <Menu lang={lang} activePage={PAGE} />
      <div id="contenu_centre">
        <h1>{LOCALES.titre.label[lang]}</h1>
        {getContent(lang, latestDataUpdate, latestUpdateISQ)}
      </div>
    </div>
  );
};

/** - TODO : API pour avoir la date de publication.
 *  - TODO : Traduction du contenu anglais.
 * @param {"fr"|"en"} lang
 * @param {string} latestDataUpdate Mois de la dernière mise à jour des données au niveau de la base de donnée
 * @param {moment.Moment|null} latestUpdateISQ Date de la dernière mise à jour selon le calendrier de diffusion ISQ
 */
function getContent(lang, latestDataUpdate, latestUpdateISQ) {
  if (lang === "en") {
    return (
      <div className="texte_petit">
        <p>
          The International Trade Data Online (ITDO) tool is{" "}
          <strong>updated monthly </strong>with the most recent data on
          international merchandise trade compiled by the Institut de la
          statistique du Québec (ISQ).
        </p>
        <p>
          Data are obtained from Statistics Canada and are compiled by the ISQ.
          They are then presented by product based on the Harmonized System (HS)
          and by industry based on the North American Industry Classification
          System (NAICS).
        </p>
        <p>
          Data on imports also include adjustments made by the ISQ to better
          reflect Québec consumption rather than the province of clearance.
          Corrections are made based on data from other surveys.
        </p>
        <p>
          It must be noted that the ITDO tool does not contain any data on
          interprovincial trade or interregional trade in Québec. Furthermore,
          only trade of goods that cross an international border is
          included—services are not included in the data.{" "}
        </p>
        <p>
          The ISQ&rsquo;s international merchandise trade data are updated every
          month of the current year, and data for previous years are revised on
          a regular basis. The ISQ&rsquo;s{" "}
          <a
            href="/en/produit/publication/release-dates"
            target="_blank"
            rel="noopener noreferrer"
          >
            release schedule
          </a>{" "}
          (in French only) provides the release dates for the ITDO in the
          &ldquo;Commerce international&rdquo; (International Trade) section.
        </p>
        <p>ITDO provides data on the past 10 years.</p>
        <p>Latest data: </p>
        <p className="gras indentation">
          Québec&rsquo;s and Canada&rsquo;s international trade in goods
        </p>
        <p className="gras indentation">
          Data available up to{" "}
          <span className="miseajour">{latestDataUpdate}</span>, released on{" "}
          <span className="miseajour">
            {dateUtil.dateToString(latestUpdateISQ, lang, "LL")}
          </span>
        </p>
        <div className="marg-t-15">
          <p>The annual revision schedule is as follows: </p>
          <ul>
            <li>For the three most recent years: in February </li>
            <li>
              For the previous year: in March, April, May, August and November{" "}
            </li>
            <li>Data for previous years may be revised if necessary</li>
          </ul>
        </div>
        <table border="0" cellPadding="0">
          <tbody>
            <tr>
              <td valign="top">
                <p>Sources:&nbsp;</p>
              </td>
              <td valign="top">
                <p>
                  Statistics Canada, International Accounts and Trade Division
                  (IATD).
                  <br />
                  Institut de la statistique du Québec, Direction des
                  statistiques économiques.
                </p>
              </td>
            </tr>
          </tbody>
        </table>
      </div>
    );
  } else {
    return (
      <div className="texte_petit">
        <p>
          L'outil Commerce international en ligne (CIEL) est{" "}
          <strong>mis à jour</strong> <strong>mensuellement</strong> avec les
          plus récentes données du commerce international de marchandises de
          l&rsquo;Institut de la statistique du Québec (ISQ).
        </p>
        <p>
          Ces données proviennent de Statistique Canada et sont compilées par
          l&rsquo;ISQ pour être présentées par produit selon le Système
          harmonisé (SH) et par industrie selon le Système de classification des
          industries de l&rsquo;Amérique du Nord (SCIAN).
        </p>
        <p>
          Aussi les données d&rsquo;importation incluent des ajustements
          <strong> </strong>de l&rsquo;ISQ pour mieux refléter la consommation
          québécoise plutôt que la province de dédouanement. Ces corrections
          sont apportées en utilisant les données disponibles dans
          d&rsquo;autres enquêtes.
        </p>
        <p>
          Il est à noter que l&rsquo;outil CIEL ne contient aucune donnée sur le
          commerce interprovincial et sur le commerce interrégional du Québec.
          Aussi, uniquement le commerce de marchandises qui passent une
          frontière internationale est inclus, les services ne sont pas
          représentés dans les données.{" "}
        </p>
        <p>
          Les données portant sur le commerce international de marchandises de
          l&rsquo;ISQ sont mises à jour tous les mois pour l&rsquo;année en
          cours et les données des années précédentes sont révisées de façon
          régulière. Le{" "}
          <a
            href="/fr/produit/publication/calendrier-de-diffusion"
            target="_blank"
            rel="noopener noreferrer"
          >
            calendrier de diffusion
          </a>{" "}
          de l&rsquo;ISQ annonce les dates de diffusion du CIEL dans la section
          «&nbsp;Commerce international&nbsp;».
        </p>
        <p>
          Les données pour les dix années les plus récentes sont disponibles
          dans le CIEL.
        </p>
        <p>Les données les plus récentes sont&nbsp;: </p>
        <p className="gras indentation">
          Commerce international de marchandises du Québec et du Canada
        </p>
        <p className="gras indentation">
          Données disponibles jusqu&rsquo;en{" "}
          <span className="miseajour">{latestDataUpdate}</span>, diffusées le{" "}
          <span className="miseajour">
            {" "}
            {dateUtil.dateToString(latestUpdateISQ, lang, "LL")}
          </span>
        </p>
        <div className="marg-t-15">
          <p>
            Le calendrier pour les révisions annuelles est comme suit&nbsp;:
          </p>
          <ul>
            <li>Trois années les plus récentes&nbsp;: en février</li>
            <li>
              Année précédente&nbsp;: en mars, avril, mai, août et novembre
            </li>
            <li>Les années précédentes pourraient être révisées au besoin</li>
          </ul>
        </div>
        <table border="0" cellPadding="0">
          <tbody>
            <tr>
              <td valign="top">
                <p>Sources&nbsp;:&nbsp;</p>
              </td>
              <td valign="top">
                <p>
                  Statistique Canada, Division du commerce et des comptes
                  internationaux.
                  <br />
                  Institut de la statistique du Québec, Direction des
                  statistiques économiques.
                </p>
              </td>
            </tr>
          </tbody>
        </table>
      </div>
    );
  }
}

export default Renseignements;
